import React from 'react'
import { Header } from '../components/Header'
import { NavigationBar } from '../components/NavigationBar'
import { Footer } from '../components/Footer'
import { Link, Outlet, useLocation } from 'react-router-dom'
import { SidebarConcursos } from '../components/SidebarConcursos'
import { ConcursoInstructivos } from './subpages/ConcursoInstructivos'
import routes from '../routes/routes'

const info = {
  pathname: "/concurso",
  indexTitle: "Concurso Especialidades y Maestrías 2026",
  text: "El proceso de selección de los aspirantes a realizar un posgrado que ofrece la División de Estudios para Graduados de la Facultad de Medicina comprende varias etapas, que deben cumplirse en forma progresiva de acuerdo a una normativa que garantice la imparcialidad, la equidad y la rectitud del mismo. \n\nPara participar, el aspirante debe inscribirse en el concurso, consignar las credenciales y esperar la evaluación de las mismas. Luego se procederá a la prueba de conocimientos (que se realiza el mismo día para todos los concursos a nivel nacional) y posteriormente a la entrevista personal que se hará probablemente en la unidad docente donde el aspirante desea cursar su programa de posgrado o a distancia. Cumplidos todos estos pasos se publicará el listado provisional de aspirantes seleccionados. Habrá un período de reconsideraciones para aquellos aspirantes que consideren que sus credenciales no fueron valoradas de manera correcta, por lo que, si se consideran a lugar algunas de las reconsideraciones, el listado provisional publicado puede ser modificado y publicado nuevamente. Siendo así, solo se considerará definitivo el listado publicado después del período de reconsideraciones, denominado LISTADO DEFINITIVO. Posteriormente se programará la fecha de la inscripción en el programa respectivo. \n\nLa División de Estudios para Graduados de la Facultad de Medicina de la Universidad del Zulia, NO GARANTIZA que durante el período del Concurso se abrirán cupos para nuevos Residentes en todos los programas de Especialidades y Maestrías, ya que los mismos están sujetos a varías consideraciones; en especial de las Instituciones que las ofertan y de las características propias de cada programa que serán consideradas por el Comité Académico y posteriormente por la División. El aspirante debe consultar los programas ofertados en el listado publicado de oferta de programas. \n\n<b>NOTA:</b> Una vez se oferte el Concurso, el mismo se publicará a través de nuestras plataformas digitales. "
}

const Concursos = () => {
  const location = useLocation();
  // const navigate = useNavigate();

  const parentRoute = routes.find((route) => route.path === "concurso");

  const subpage = location.pathname.split('/').pop()

  const currentRoute = parentRoute.children.find((page) => page.path === subpage) ?? 'index'

  // useEffect(() => {
  //   if (location.pathname === info.pathname || subpage === '') {
  //     navigate(info.pathname + '/descripcion');
  //   }
  // }, [location, subpage, navigate]);

  return (
    <>
    <Header />
    <NavigationBar activeLink={parentRoute.title} />
    <main className={`main main-concursos ${(location.pathname !== info.pathname) ? 'subpage' : 'standard' }`}>
        <div className='page-header'>
          <Link to={info.pathname} className='header-title'>{parentRoute.longTitle}</Link>
        </div>
        <section className='central-container concursos'>
          <div className='section-header'>
            <h2 className='section-title'>{currentRoute !== 'index' ? currentRoute.displayTitle : info.indexTitle}</h2>
          </div>
          <div className='section-body'>
          {
            location.pathname === info.pathname ?
            <ConcursoInstructivos />
            :
            <Outlet />
          }
          </div>
        </section>
        <SidebarConcursos pathname={location.pathname} />
    </main>
    <Footer />
    </>
  )
}

export { Concursos }